import { missingNativeBuild } from "../nativeError";
var DeviceAttestation = Object.freeze({
  getAvailability: function getAvailability() {
    return {
      appAttest: false,
      deviceCheck: false
    };
  },
  generateKey: function generateKey() {
    return Promise.reject(missingNativeBuild("DeviceAttestation.generateKey"));
  },
  attestKey: function attestKey(_keyId, _clientDataHashBase64) {
    return Promise.reject(missingNativeBuild("DeviceAttestation.attestKey"));
  },
  generateAssertion: function generateAssertion(_keyId, _clientDataHashBase64) {
    return Promise.reject(missingNativeBuild("DeviceAttestation.generateAssertion"));
  },
  generateDeviceToken: function generateDeviceToken() {
    return Promise.reject(missingNativeBuild("DeviceAttestation.generateDeviceToken"));
  }
});
export {
  DeviceAttestation
};
//# sourceMappingURL=unavailable.js.map
